
/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};


/**
 * Intesa loan calculator BIB
 *
 */
Intesa.InvestmentCalculatorVUB = function() {
    
	/**
	 * Local variables
	 *
	 */
	var loan = this;
	var development = false;
	var invalidJsonFiles = false;
	var genericSettings = {};
	var calculatorLabels = {};
	var extServices = {};

	/**
	 * Global variables
	 *
	 */
	this.MAX_ITERATIONS = 50;
	this.activeCalculator = null;
	this.activeVariant = {};
	this.activeMortgage = {};
	this.activeCurrency = {};
	this.activeInterestType = {};
	this.errorState = false;
	this.defaultEducation = null;
	this.productCategory = "";
	this.eurizonMutualFund = 0;
	this.month12Appreciation = 0;
	this.investmentChart=null;

	// values
	this.portfolios = {}
	this.funds = {}
	this.savingsAccounts = {}
	this.targetAmount = 0;
	this.selectedFunds = [];
	this.singleFundInvestment = 0;
	this.tenor = 0;
	this.tenorUnit = null;
	this.monthlyInstallment = 0;
	this.investmentAmount = 0;
	this.activePortfolioCode = "";
	this.activeFundCode = "";
	this.activeSavingsAccountCode = "";
	this.yield = 0;
	this.currency = null;
	this.urlParams = {};


    /**
     * Init component
     *
     */
    this.init = function() {

        // check if calculator exists
        var isVUB = $('html').attr('data-bank') == 'VUB';
		var isInvestmentCalculator = $('.investment-calculator').length > 0;
        if (!$("section.com16-14").length || !isVUB || !isInvestmentCalculator) return;
		
		// get settings and labels
		loan.getSettingsAndLabelsJsonData();
		//loan.fetchPortfoliosData();

        loan.setVisibleCalculatorAsActive();
        loan.setActiveVariant();
        loan.setActiveMortgage( loan.getDefaultMortgage() );
		loan.setActiveCurrency( loan.getDefaultCurrency() );
		loan.setActiveInterestType( loan.getDefaultInterestType() );
        loan.mapSliders();

        loan.attachChangeEvents();

		loan.updateProductCategory();
        loan.updateCalculatorInputs();
		loan.updateCalculatorOutputs();

		if(loan.getProductCategory() === "SAVINGS_ACCOUNT" || loan.getProductCategory() === "COMBIPRODUCT") {
			loan.attachDataLayerClickEvent();
		}

		loan.formatInputDecimal();

    };

	/**
		 * 
		 * init and set data for chart
		 * @param {*} params 
		 */
	this.initChart = function () {
		var dataValue = [];
		var dataLabel = [];
		var data;
		console.log(loan.getProductCategory());
		if (loan.getProductCategory() == "INVESTMENT_PORTFOLIOS") {
			data = loan.getInvestmentPortfolioData();
			console.log(data);
			dataLabel = data[0];
			dataValue = data[1];
		} else if (loan.getProductCategory() == "INVESTMENT_SAVINGS")  {
			data = loan.getInvestmentSavingData();
			console.log(data);
			dataLabel = data[0];
			dataValue = data[1];
		}else{
			return;
		}
		var legend=document.getElementById("chartLegend").getAttribute("value");
		const colorChart = $('.content-target__wrapper').css("background-color");
		Chart.defaults.font.size = 14;
		const config = {
			type: 'line',
			data: {
				labels: dataLabel,
				datasets: [{
					label: legend,
					data: dataValue,
					fill: true,
					borderColor: colorChart,
					tension: 0.1,
					pointStyle: 'line'
				}]
			},
			options: {
				scales: {
					y: {
						ticks: {
							callback: function(value, index, values) {
								return value + ' \u20AC';
							}
						}
					}
				},
				devicePixelRatio: 2,
				plugins: {
					legend: {
						display:false,
						position: 'bottom',
						align: 'center',
						labels:{
							usePointStyle: true,
							pointStyle:"circle",
							boxWidth:8,
							boxHeight:10
						}
				  	}
				}
			}
		};

		if($(window).width() < 768){
			var ctx = document.getElementById('chartCanvasMobile');
		} else{
			var ctx = document.getElementById('chartCanvas');
		}
		

		if (loan.investmentChart != undefined || loan.investmentChart != null) {
			loan.investmentChart.destroy();
			loan.investmentChart = new Chart(ctx, config);
		} else {
			loan.investmentChart = new Chart(ctx, config);
		}
	};

	/**
	 * Get Investment portfolio data
	 */
	this.getInvestmentPortfolioData = function () {
		var dataValue = [];
		var dataLabel = [];
		var activePortfolioValue = loan.portfolios[this.activePortfolioCode];
		for (var i = 0; i < loan.tenorInYears; i++) {
			console.log("Anno n" + i + 1 + ": " + loan.investmentAmount * Math.pow((1 + activePortfolioValue / 100), i + 1))
			dataValue[i] = loan.investmentAmount * Math.pow((1 + activePortfolioValue / 100), i + 1);
			console.log(dataValue[i]);
			dataLabel[i] = i + 1;
		}
		return [dataLabel, dataValue];
	};
	
	/*
	 * Get Investment saving data
	 */
	this.getInvestmentSavingData = function () {
		var dataValue = [];
		var dataLabel = [];
		var activeFundValue = loan.funds[loan.activeFundCode];
		var j = 0;
		if($(window).width() < 768){
			var inputFieldInvestmentAmount = parseInt($("[name=investmentAmount]")[1].value);
		} else{
			var inputFieldInvestmentAmount = parseInt($("[name=investmentAmount]")[0].value);
		}
		
		for (var i = 0; i < loan.tenorInYears; i++) {
			j = i + 1;
			dataValue[i] = 0 - loan.FV(
				Math.pow(1 + (activeFundValue / 100), 1 / 12) - 1,
				j * 12,
				loan.monthlyInstallment,
				inputFieldInvestmentAmount + loan.monthlyInstallment,
				1
			);
			console.log(dataValue[i]);
			dataLabel[i] = i + 1;
		}
		return [dataLabel, dataValue];
	};
	
	/**
	 * Get Calculator Inputs
	 *
	 */
	this.getCalculatorInputs = function() {

		var inputs = $( '[data-algorithm-input]', loan.activeCalculator );
		var numberOfInputs = inputs.length;

		for( var i = 0; i < numberOfInputs; i++ ) {

			// get name
			var inputLabel = inputs[i].getAttribute( 'data-algorithm-input' );

			// get value
			var inputValue = inputs[i].value;

			//replace comma with dot
            inputValue = inputValue.replace(',', '.').replaceAll(genericSettings.separator, '');


			// parse numbers
			if( inputLabel !== 'currency' )	inputValue = parseFloat( inputValue );

			// set global property
			loan[inputLabel] = inputValue;

		}

	};


    /**
     * Append Calculator Outputs
     *
     */
    this.appendCalculatorOutputs = function() {
		const decimalDataLabels = 
			['monthlyInstallment', 
			 'investmentAmount', 
			 'yield', 
			 'investmentValue', 
			 'month12TermDeposit', 
			 'eurizonMutualFund', 
			 'singleFundInvestment', 
			 'month12Appreciation', 
			 'saverContribution', 
			 'savedAmount'
		];

        var outputs = $('[data-algorithm-output]', loan.activeCalculator);
		var outputValue = "";

        outputs.each(function() {
            var inputLabel = $(this).attr('data-algorithm-output');
            if ( decimalDataLabels.includes(inputLabel) ) {
                outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal, genericSettings.separator);
			}
			else if (inputLabel == "selectedPortfolio" && loan.activePortfolioCode) {
				outputValue = calculatorLabels.portfolio[loan.activePortfolioCode];
			}
			else {
            	outputValue = loan[inputLabel];
			}

            $(this).text(outputValue);
        });

    };


    /**
     * Set Visible Calculator As Active
     *
     */
    this.setVisibleCalculatorAsActive = function() {

		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']' );
        var calculatorFound = false;

        calculators.each(function() {

            // set visible calculator as active
            if ($(this).is(":visible")) {

                loan.activeCalculator = $(this);
                calculatorFound = true;
            }

        });

        // handle no calculator active by default
        if (!calculatorFound) loan.activeCalculator = $('[data-calculator='+calculatorResolution+']').first();

		if( calculatorResolution === 'mobile')
		{
			$('.calculator-desktop').hide();
		}
		
    };


    /**
     * Set Active Variant
     *
     */
    this.setActiveVariant = function() {

        if (loan.activeCalculator) {

            var calculatorData = loan.activeCalculator.siblings('.calculatorData').val();

            try {

                // get calculator data
                var variantData = JSON.parse(calculatorData);
                loan.activeVariant = variantData.glGenericSimulatorParams;

            } catch (e) {

                console.error('Calculator JSON file invalid');

            }

        }

    };


	/**
	 * Set Active Mortgage
	 *
	 */
	this.setActiveMortgage = function( value ) {

		var mortgageOptions = loan.activeVariant.glProductVariantList;
		var numberOfMortgage = mortgageOptions.length;

		// cicle all the martgage options
		for( var i = 0; i < numberOfMortgage ; i++ ) {

			if( mortgageOptions[i].variantType === value ) {

				loan.activeMortgage = mortgageOptions[i];
				break;

			}

		}

		loan['mortgage'] = value;

	};


	/**
	 * Get Default Mortgage
	 *
	 */
	this.getDefaultMortgage = function() {

		if( loan.activeVariant ) {

			var mortgageOptions = loan.activeVariant.glProductVariantList;
			var numberOfMortgage = mortgageOptions.length;
			var label = '';
			var mortgageFound = false;

			// cicle all the martgage options
			for( var i = 0; i < numberOfMortgage ; i++ ) {

				if( mortgageOptions[i].default === true ) {

					label = mortgageOptions[i].variantType;
					loan['mortgage'] = label;
					mortgageFound = true;
					break;

				}

			}

			if( !mortgageFound ) label = mortgageOptions[0].variantType;

			loan['mortgage'] = label;

			return label;

		}

	};


	/**
	 * Set Active Currency
	 *
	 */
	this.setActiveCurrency = function( value ) {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var numberOfCurrency = currencyOptions.length;

		// cicle all the currencies
		for( var i = 0; i < numberOfCurrency ; i++ ) {

			if( currencyOptions[i].currency === value ) {

				loan.activeCurrency = currencyOptions[i];
				break;

			}

		}

	};


	/**
	 * Get Default Currency
	 *
	 */
	this.getDefaultCurrency = function() {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var numberOfCurrency = currencyOptions.length;
		var label = '';

		// cicle all the currencies
		for( var i = 0; i < numberOfCurrency ; i++ ) {

			if( currencyOptions[i].default === true ) {

				label = currencyOptions[i].currency;
				break;

			}

		}

		return label;

	};


	/**
	 * Get Settings And Labels Json Data
	 *
	 */
	this.getSettingsAndLabelsJsonData = function() {

		var settings = $( "#genericSettings" );
		var labels = $( "#calculatorLabels" );

		try {

			// get generic settings
			if( settings.length ) {
				genericSettings = JSON.parse( settings.val() );
			}

			// get calculator labels
			if( labels.length ) {
				calculatorLabels =  JSON.parse( labels.val() );
			}

		} catch(e) {

			console.error( 'Settings or Labels JSON file invalid' );
			invalidJsonFiles = true;

		}

	};

	/**
	 * Update Calculator Inputs
	 *
	 */
	this.updateCalculatorInputs = function() {
		loan.updatetargetAmountInput();
		loan.updateExpectedAnnualIncomeInput();
		loan.updateMonthlyDepositInput();
        loan.updateCurrencySelect();
		loan.updateTenorUnit();
        loan.updateTenorSlider();

		//Inserire l'aggiornamento dei dati del chart

		loan.initSavingsAccountSelect( loan.loadInterestRates() );

		if( loan.productCategory === "INVESTMENT_PORTFOLIOS"){
			loan.initPortfolioTypesSelect( this.loadPortfoliosData() );
		}
		
		if( loan.productCategory === "INVESTMENT_SAVINGS"){
			loan.initFundTypesSelect( this.loadFundsData(), "DOP" );
		}

		if( loan.productCategory === "COMBIPRODUCT") {
			loan.initCombiFundsSelect( this.loadFundsData() );
		}
	};


	/**
	 * Update Calculator Outputs
	 */
	this.updateCalculatorOutputs = function() {
        loan.getCalculatorInputs();
		loan.checkErrors();
		loan.calculateResults();
        loan.appendCalculatorOutputs();
		loan.initChart();

		loan.updateDataLayer();
    };


	/**
	 * Update Amount Input
	 *
	 */
	this.updatetargetAmountInput = function() {
		var input = $( '[data-algorithm-input="targetAmount"]', loan.activeCalculator );
		if(input.length === 0) 
			var input = $( '[data-algorithm-input="investmentAmount"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minimumAmount;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxAmountForOnline;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultAmount;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-loan-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}

	};
	
	/**
	 * Update Expected Annual Income Input
	 *
	 */
	this.updateExpectedAnnualIncomeInput = function() {

		var input = $( '[data-algorithm-input="expectedAnnualIncome"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minExpectedAnnualIncome;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxExpectedAnnualIncome;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultExpectedAnnualIncome;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-expected-annual-income-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-expected-annual-income-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
				defaultAmount = number_format( defaultAmount, 2, genericSettings.decimal, genericSettings.separator );
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley(loan.formatParsleyDecimalValue()).validate();

		}
	};


	/**
	 * Update Currency Select
	 *
	 */
	this.updateCurrencySelect = function() {

		var currencyOptions = loan.activeMortgage.glConfigurationList;
		var select = $( '[data-algorithm-input="currency"]', loan.activeCalculator );
		var html = '';

		if( select.length ) {

			// clear select
			select.html('');

			// generate select html
			currencyOptions.forEach( function( currency ) {

				currency = currency.currency;

				if( currency === loan.activeCurrency.currency ) {
					html += '<option value="' + currency + '" selected>' + currency + '</option>';
				} else {
					html += '<option value="' + currency + '">' + currency + '</option>';
				}

			} );

			if(currencyOptions.length <= 1)
			{
				select.attr('disabled', 'disabled')
			}

			// append options
			select.append( html );

		}

	};


	/**
	 * Map Sliders
	 *
	 */
	this.mapSliders = function() {
		if(window.sliderbootstrap) {
			var sliders = window.sliderbootstrap;

			// map every slider with its instance inside sliderbootstrap window property
			sliders.forEach( function( item, index ) {

				item.attr( 'data-slider-index', index );

			} );
		}
	};


	/**
	 * Get Tenor In Months
	 *
	 */
	this.getTenorInMonths = function() {

		if( loan.tenorUnit === 'YEARS' ) loan.tenor = loan.tenor * 12;

	};



	/**
	 * Update Tenor Unit
	 *
	 */
	this.updateTenorUnit = function() {

		// get tenor unit
		loan.tenorUnit = loan.activeCurrency.tenorUnit;

		// get label
		var tenorUnitLabel = calculatorLabels[loan.tenorUnit];

		// insert label
		$( '[data-tenor-unit]', loan.activeCalculator ).text( tenorUnitLabel );

	};


	/**
	 * Update Tenor Slider
	 *
	 */
	this.updateTenorSlider = function() {

		var input = $( '.rangeslider.rangeslider--2', loan.activeCalculator );

		if( input.length ) {

			var index = parseInt( input.attr( 'data-slider-index' ) );
			var slider = window.sliderbootstrap[index];
			var wrapper = input.parents('.sliderRange__wrapper');

			// set step value
			var step = loan.activeCurrency.glGenericCalculationList[0].amountList[0].tenorScalingFactor;
			input.attr( 'data-slider-step', step );

			// set minimum
			var tenorMin = loan.activeCurrency.glGenericCalculationList[0].amountList[0].minimumTenor;
			if (loan.activeInterestType.periods  === 2 && tenorMin <= loan.activeInterestType.firstPeriod.monthDuration){
				tenorMin = (loan.activeInterestType.firstPeriod.monthDuration + 12);
			}
			if( loan.tenorUnit === 'YEARS' ) tenorMin = tenorMin / 12;
			input.attr( 'data-slider-min', tenorMin );
			wrapper.find( '[data-min-tenor]' ).html( tenorMin );

			// set maximum
			var tenorMax = loan.activeCurrency.glGenericCalculationList[0].amountList[0].maximumTenor;
			if( loan.tenorUnit === 'YEARS' ) tenorMax = tenorMax / 12;
			input.attr( 'data-slider-max', tenorMax );
			wrapper.find( '[data-max-tenor]' ).html( tenorMax );

			// rebuild slider
			slider.slider('destroy');
			slider.slider({ tooltip: 'show' });


			var tenorDefault = loan.activeCurrency.glGenericCalculationList[0].amountList[0].defaultTenor ?  loan.activeCurrency.glGenericCalculationList[0].amountList[0].defaultTenor : tenorMin;
			if( loan.tenorUnit === 'YEARS' ) tenorDefault = tenorDefault / 12;

			var $mobileInput = $('input[data-algorithm-input="loanDuration"]', loan.activeCalculator);

			if($mobileInput.length > 0) {
				$mobileInput.attr("data-parsley-min", slider.attr("data-slider-min"));
				$mobileInput.attr("data-parsley-max", slider.attr("data-slider-max"));
				$mobileInput.val(tenorDefault);
				$mobileInput.parsley().validate();
			}

            var $minValue = $( '[data-min-tenor]', loan.activeCalculator ); $minValue.html( tenorMin );
            var $maxValue = $( '[data-max-tenor]', loan.activeCalculator ); $maxValue.html( tenorMax );

			if(loan.tenorUnit === "YEARS") {
				$minValue.next('[data-tenor-unit]').html( loan.getYearsLabel( tenorMin ) );
				$maxValue.next('[data-tenor-unit]').html( loan.getYearsLabel( tenorMax ) );
			}
           
			// attach slide event
			slider.slider('setValue', tenorDefault);
			wrapper.find('.qty').val(tenorDefault);
			input.siblings( '.qty' ).trigger('change');

			slider.on( 'slide', function() {
				var value = slider.slider('getValue');
				wrapper.find('.qty').val(value);
				input.siblings( '.qty' ).trigger('change');
			} );

		}

	};

	 /**
     * Set Active Calculator
     *
     */
    this.setActiveCalculator = function(calculator) {

        loan.activeCalculator = calculator;

    };



	/**
	 * Attach Change Events
	 *
	 */
	this.attachChangeEvents = function() {

        $(document).on('click', '.com15__filterItem', function() {
            var id = $(this).attr('data-filter');
            var calculators = $('.com15__filter[data-filter="' + id + '"]');
			var calculator;
			if($(window).width() < 768) {
				calculator = calculators.find('.calculator-mobile');
			}
			else {
				calculator = calculators.find('.calculator-desktop');
			}

            //	loan['loanpurpose'] = id;
            loan.setActiveCalculator(calculator);
            loan.setActiveVariant();
			loan.updateProductCategory();
            loan.setActiveMortgage(loan.getDefaultMortgage());
            loan.setActiveCurrency(loan.getDefaultCurrency());
            loan.setActiveInterestType(loan.getDefaultInterestType());
            loan.updateCalculatorInputs();
            loan.updateCalculatorOutputs();
        });

		// enable change slider on click
		$( document ).on( "change", '.rangeslider', function() {
			var value = $( this ).val();
			var wrapper = $( this ).parents( '.sliderRange__wrapper' );
			wrapper.find( '.qty' ).val( value );
			loan.updateCalculatorOutputs();
		} );
		
		$(document).on('keyup', 'input[data-algorithm-input="loanDuration"]', function () {
			var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
			var index = parseInt(slider.attr('data-slider-index'));
			slider.slider('setValue', $(this).val(), true);
		});
		
		$( document ).on( 'change' , '.js-portfolio-select', function() {
			loan.activePortfolioCode = $(this).val();
			loan.updateCalculatorOutputs();
		});


		$( document ).on( 'change' , '.js-fund-select', function() {
			loan.activeFundCode = $(this).val();
			loan.updateCalculatorOutputs();
		});
		
		$( document ).on( 'change' , '.js-savings-account-select', function() {
			loan.activeSavingsAccountCode = $(this).val();
			loan.updateCalculatorOutputs();
		});

		// on change inputs
		$( document ).on( 'focusout', '[data-algorithm-input]', function() {
			loan.checkInvestmentAmount();
			loan.updateCalculatorOutputs();
		});

		$( document ).on( 'change  keyup', '[data-algorithm-input]', function() {
			loan.updateCalculatorOutputs();
		});


		// on click slider buttons
		$( document ).on( "click", '.js-btnMinus, .js-btnAdd', function() {
			$( '[data-algorithm-input="tenorInYears"]' ).trigger( 'change' );
		} );

		$( document ).on("click", '.js-calculator-gotop', function(e) {
			e.preventDefault();
			$(window).scrollTop( $('.mobile-loan', loan.activeCalculator).offset().top);
		});

		$( document ).on( "click", '.js-combi-select-item', function() {
			var $cs_item = $(this);

			if($cs_item.hasClass("selected")) {
				$cs_item.removeClass("selected");
				$itemIcon = $cs_item.find(".cs-item__icon");
				if($itemIcon){
					$itemIcon.addClass("ic-circle-cross");
					$itemIcon.removeClass("ic-check");
				}

				var fundCode = $cs_item.attr("data-fund-code");
				if(loan.selectedFunds.indexOf(fundCode) != -1) {
					loan.selectedFunds = loan.selectedFunds.filter(function(f) { return f != fundCode; });
				}
			}
			else {
				$cs_item.addClass("selected");

				$itemIcon = $cs_item.find(".cs-item__icon");
				if($itemIcon){
					$itemIcon.removeClass("ic-circle-cross");
					$itemIcon.addClass("ic-check");
				}

				var fundCode = $cs_item.attr("data-fund-code");
				
				if(loan.selectedFunds.indexOf(fundCode) == -1) {
					loan.selectedFunds.push(fundCode);
				}
			}

			loan.updateCalculatorOutputs();

			var $alertMessage = $cs_item.parents('.calculator-field').find(".alertMessage");

			if(!loan.singleFundInvestment || loan.singleFundInvestment <= 150) {
				$alertMessage.removeClass('hide');
			}
			else {
				$alertMessage.addClass('hide');
			}

		});

		//Manage results sticky position
		if($(window).width() < 768){
			var section = loan.activeCalculator;
			var initialSectionHeight = section.height();
			$(window).on('scroll', function() {
				var results = $( '.mobile-loan .tab-results',loan.activeCalculator);
				var calculator = $('.mobile-loan .loanCalculator', loan.activeCalculator);

				section.height( initialSectionHeight );

				var distanceFromTop = calculator.offset().top - $(window).scrollTop();
				var distanceFromBottom = calculator.offset().top + calculator.height() + results.height() - ($(window).scrollTop() + $(window).innerHeight());

				var delta = 160;

				if (!(distanceFromBottom < 0) && (distanceFromTop < 0 - delta)) {
					results.css("position", "fixed");
					results.css("bottom", 0);
					section.height( initialSectionHeight );
				}
				else if (!(distanceFromBottom < 0) && (distanceFromTop < (section.height() - calculator.height()) - delta)) {
					results.css("position", "fixed");
					results.css("bottom", 0 - distanceFromTop - delta);
					section.height( initialSectionHeight );
				}
				else {
					results.css("position", "static");
					section.height('auto');
				}

			});
		
		}

    };
	
    /**
	 * Set Active Interest Type
	 *
	 */
	this.setActiveInterestType = function( value ) {
		if(!value) return

		var interestOptions = loan.activeCurrency.glGenericCalculationList[0].interest;
		var numberOfInterests = interestOptions.length;

		// cicle all interest rates
		for( var i = 0; i < numberOfInterests ; i++ ) {

			if( interestOptions[i].interestCode === value ) {

				loan.activeInterestType = interestOptions[i];
				loan['interestRateType'] = value;
				break;

			}

		}

	};

	this.checkInvestmentAmount = function(){
		var input = $("[name=investmentAmount]", loan.activeCalculator);
		if (parseInt(input.val()) > parseInt(input.attr("data-parsley-max"))){
			input.val(input.attr("data-parsley-max"));
			input.parsley().validate();
		}
		if(parseInt(input.val()) < parseInt(input.attr("data-parsley-min"))){
			input.val(input.attr("data-parsley-min"));
			input.parsley().validate();
		}
	};


	/**
	 * Get Default Interest Type
	 *
	 */
	this.getDefaultInterestType = function() {

		var interestOptions = loan.activeCurrency.glGenericCalculationList[0].interest;
		if(interestOptions != null) {
			var numberOfInterests = interestOptions.length;
			var label = '';

			// cicle all interest rates
			for( var i = 0; i < numberOfInterests ; i++ ) {

				if( interestOptions[i].default === true ) {

					label = interestOptions[i].interestCode;
					break;

				}

			}

			return label;
		}

	};


	/**
	 * Get Tenor In Months
	 *
	 */
	this.getTenorInMonths = function() {

		if( loan.tenorUnit === 'YEARS' ) loan.tenor = loan.tenorInYears * 12;

	};

	
	/**
	 * Check Errors
	 *
	 */
	this.checkErrors = function() {

		// get parsley errors
		var errors = $( '.parsley-errors-list li', loan.activeCalculator ).length;

		if( errors > 0 ) {

			loan.errorState = true;

		} else {

			loan.errorState = false;

		}

	};


	/**
	 * Calculate Monthly Installments
	 */
	this.calculateResults = function() {
		if(loan.errorState === true) return;

		var activePortfolioValue = loan.activePortfolioValue;

		if(loan.productCategory === 'TARGET_AMOUNT') {
			var targetAmount = loan.targetAmount;		
			var investmentPeriod = loan.tenorInYears * 12;
			var expectedAnnualIncome = loan.expectedAnnualIncome / 100;

			loan.monthlyInstallment = ( (expectedAnnualIncome/12) / ( Math.pow( 1 + expectedAnnualIncome/12, investmentPeriod) -1 ) )* targetAmount;
			loan.investmentAmount = loan.monthlyInstallment * investmentPeriod;
			loan.yield = targetAmount - loan.investmentAmount;
		}
		else if(loan.productCategory === 'INVESTMENT_PORTFOLIOS') {
			var investmentPeriod = loan.tenorInYears;
			var activePortfolioValue = loan.portfolios[this.activePortfolioCode];

			if(activePortfolioValue) {
				loan.investmentValue = loan.investmentAmount*Math.pow((1+ activePortfolioValue/100), investmentPeriod)
				loan.yield = loan.investmentValue - loan.investmentAmount;
			}
		}
		else if(loan.productCategory === 'INVESTMENT_SAVINGS') {
			var investmentPeriod = loan.tenorInYears;
			var monthlyDeposit = loan.monthlyInstallment;
			var oneTimeDeposit = loan.investmentAmount;
			var activeFundValue = loan.funds[loan.activeFundCode];

			loan.investmentAmount = oneTimeDeposit + (monthlyDeposit*investmentPeriod*12);

			if(activeFundValue){
				
				loan.investmentValue = 0 - loan.FV(
					Math.pow( 1 + ( activeFundValue/100), 1/12) - 1,
					investmentPeriod*12,
					monthlyDeposit,
					oneTimeDeposit + monthlyDeposit,
					1
				); 
				
				loan.yield = loan.investmentValue - loan.investmentAmount;
			}

		}else if(loan.productCategory === 'SAVINGS_ACCOUNT') {
			if(loan.activeSavingsAccountCode) {
				var activeSavingsAccountValue = loan.savingsAccounts[loan.activeSavingsAccountCode]/100;
				loan.saverContribution = loan.investmentAmount + ( loan.monthlyInstallment * loan.tenorInYears * 12 );
				loan.savedAmount = round( loan.investmentAmount * (1 + (activeSavingsAccountValue * loan.tenorInYears )) + loan.monthlyInstallment*(  Math.pow(1+ activeSavingsAccountValue/12, loan.tenorInYears*12) - 1) /(activeSavingsAccountValue/12), 2 );
			}
		}else if(loan.productCategory === 'COMBIPRODUCT') {
			var interestRate = loan.activeInterestType.firstPeriod.interestRate;
			
			if(loan.selectedFunds.length > 0) {
				var investmentAmount = loan.investmentAmount;

				loan.month12TermDeposit = Math.round(loan.investmentAmount/3);
				loan.eurizonMutualFund = Math.round(loan.investmentAmount - loan.month12TermDeposit);

				loan.singleFundInvestment = loan.eurizonMutualFund / loan.selectedFunds.length;

				var totalYield = 0;
				loan.selectedFunds.forEach(function(fundCode) {
					totalYield += loan.calculateSingleFundYield(loan.investmentAmount / loan.selectedFunds.length, interestRate/100, loan.funds[fundCode]);
				});

				loan.month12Appreciation = Math.floor(totalYield);
			}
			else {
				loan.month12TermDeposit = 0;
				loan.eurizonMutualFund = 0;
				loan.month12Appreciation = 0;
			}
		}
	};


	/**
	 * Load Portfolios Data
	 */
	this.loadPortfoliosData = function() {
        if (loan.activeCalculator) {
			var portfoliosJson = $(".portfoliosData").val();

			try {
				var portfoliosData = JSON.parse(portfoliosJson);

				return portfoliosData.funds;
			}
			catch(e) {
				console.log("Error when loading portfolios data.")
			}
		}
	}

	/**
	 * Load Funds Data
	 */
	this.loadFundsData = function() {
        if (loan.activeCalculator) {
			var fundsJson = $(".fundsData").val();

			try {
				var fundsData = JSON.parse(fundsJson);

				return fundsData.funds;
			}
			catch(e) {
				console.log("Error when loading funds data.")
			}
		}
	}


	/**
	 * Load Fund Codes
	 */
	this.loadFundCodes = function() {
        if (loan.activeCalculator) {
			var jsonString = $(".fundCodes").val();

			try {
				var parsedJson = JSON.parse(jsonString);

				return parsedJson;
			}
			catch(e) {
				console.log("Error when loading fund codes data.")
			}
		}
	}
	
	/**
	 * Load Interest Rates 
	 */
	this.loadInterestRates = function() {
        if (loan.activeCurrency) {
			return loan.activeCurrency.glGenericCalculationList[0].interest;
		}
	}

	/**
	 * Init the portfolio types select field
	 */
	this.initPortfolioTypesSelect = function(portfolio, defaultValue) {
		if(!portfolio) return;

		var $select = $('.js-portfolio-select', loan.activeCalculator);
		$select.html('');

		if($select.length && calculatorLabels.portfolio) {
			var codes = Object.keys(portfolio);

			for(var i = 0; i < codes.length; i++) {
				loan.portfolios[codes[i]] = portfolio[codes[i]];
				$select.append($('<option value="' + codes[i] + '">'+ calculatorLabels.portfolio[codes[i]] +'</option>'));
			}

			loan.activePortfolioCode = codes.includes(defaultValue) ? defaultValue : codes[0];

			$select.val(loan.activePortfolioCode);

			$select.trigger('change');
		}

	}


	/**
	 * Init the fund types select field
	 */
	this.initFundTypesSelect = function(funds, defaultValue) {
		if(!funds) return;

		var $select = $('.js-fund-select', loan.activeCalculator);
		$select.html('');

		var codes = [];
		if($select.length && calculatorLabels.fund) {
			var codes = loan.loadFundCodes();

			for(var i = 0; i < codes.length; i++) {
				loan.funds[codes[i]] = funds[codes[i]];
				$select.append($('<option value="' + codes[i] + '">'+ calculatorLabels.fund[codes[i]] +'</option>'));
			}

			loan.activeFundCode = codes.includes(defaultValue) ? defaultValue : codes[0];

			$select.val(loan.activeFundCode);

			$select.trigger('change');
		}

	}
	
	/**
	 * Init savings account select field
	 */
	this.initSavingsAccountSelect = function(savingsAccounts) {
		if(!savingsAccounts) return;

		var $select = $('.js-savings-account-select', loan.activeCalculator);
		var defaultAccount = 0;
		$select.html('');

		if($select.length) {
			for(var i = 0; i < savingsAccounts.length; i++) {
				var code = savingsAccounts[i].interestCode;

				var isDefault = savingsAccounts[i].default;

				if(isDefault) {
					defaultAccount = i;
				} 

				loan.savingsAccounts[code] = savingsAccounts[i].firstPeriod.interestRate;
				$select.append($('<option value="' + code + '">'+ (calculatorLabels.savingsAccount[code] || "") +'</option>'));
			}

			$select.val(savingsAccounts[defaultAccount].interestCode);

			$select.trigger('change');
		}

	}


	/**
	 * Init the combi funds select field
	 */
	this.initCombiFundsSelect = function(funds) {
		if(!funds) return;

		var $select = $('.js-combi-funds-select', loan.activeCalculator);
		var $selectItemModel = $($select.find('.js-combi-select-item')[0]);

		$select.html("");

		if($select.length && calculatorLabels.fund) {
			var fundCodes = loan.loadFundCodes();

			fundCodes.forEach(function(code) {

				var fundLabel = calculatorLabels.fund[code]

				loan.funds[code] = funds[code];

				$selectItem = $selectItemModel.clone();
				$selectItem.attr("data-fund-code", code)
				$selectItem.toggle(true);

				$selectItem.find('.cs-item__label').text(fundLabel);
				$select.append($selectItem);
			});
		}

	}

	
	/**
	 * Update product category
	 */
	this.updateProductCategory = function() {
		if(loan.activeVariant) {
			loan.productCategory = loan.activeVariant.productCategory;
		}
	}

	/**
	 * Update Monthly Deposit Input
	 *
	 */
	this.updateMonthlyDepositInput = function() {

		var input = $( '[data-algorithm-input="monthlyInstallment"]', loan.activeCalculator );

		if( input.length ) {

			var minimumAmount = loan.activeCurrency.glGenericCalculationList[0].minMonthlyDeposit;
			var maximumAmount = loan.activeCurrency.glGenericCalculationList[0].maxMonthlyDeposit;
			var defaultAmount = loan.activeCurrency.glGenericCalculationList[0].defaultMonthlyDeposit;

			// update minimum
			input.attr( 'data-parsley-min', minimumAmount );
			var min = number_format( minimumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-monthly-deposit-min]', loan.activeCalculator ).text( min );

			// update maximum
			input.attr( 'data-parsley-max', maximumAmount );
			var max = number_format( maximumAmount, 2, genericSettings.decimal, genericSettings.separator );
			$( '[data-monthly-deposit-max]', loan.activeCalculator ).text( max );

			// insert default value if the value is 0
			if ((	input.val() == "0" || parseInt(input.val() ) < defaultAmount)){
			
				input.val( defaultAmount );

			}

			// validate
			input.parsley().validate();

		}
	};

	/**
	 * Calculate Future Value
	 */
	this.FV = function FV(rate, nper, pmt, pv, type) {
  		var pow = Math.pow(1 + rate, nper), fv;
  		if (rate) {
   			fv = (pmt*(1+rate*type)*(1-pow)/rate)-pv*pow;
  		} else {
   			fv = -1 * (pv + pmt * nper);
  		}
  		return fv;
	};

	/**
	 * Calculate fund yield for combi product
	 */
	this.calculateSingleFundYield = function( investmentAmount, interestRate, fundValue) {
		var monthTermDeposit = ((investmentAmount/3)*interestRate)+(investmentAmount/3);
		var eurizonMutualFund = ((((investmentAmount/3)*2)*fundValue/100)+((investmentAmount/3)*2))
		
		return monthTermDeposit + eurizonMutualFund - investmentAmount;
	}
	

	/**
	 * Defines if an input can contain decimals
	 */
	this.formatInputDecimal = function() {
		var $inputs;

		$inputs = $('[data-format-decimal]');
		if( $inputs.length ) {
			$inputs.each(function() {
				new Cleave( this, {
					delimiter: '',
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 2,
					numeralThousandsGroupStyle: 'thousand'
				} );
			})

		}
		
		$inputs = $('[data-format-no-decimal]');
		if( $inputs.length ) {
			$inputs.each(function() {
					new Cleave( this, {
					delimiter: '',
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 0,
					numeralThousandsGroupStyle: 'thousand'
				});
			});	
		}
	}


	this.formatParsleyDecimalValue = function() {
		return {
			value: function(parsley) { 
				return $(parsley.element).val().replaceAll(genericSettings.separator, '').replace(genericSettings.decimal,'.'); 
			}
		};

	}


	this.updateDataLayer = function() {
		var dataLayerValue = "";
		var productCategory = loan.activeVariant.productCategory;

		if(productCategory === "SAVINGS_ACCOUNT") {
			dataLayerValue = '{ "event": "saving_calculator", "eventCategory": "saving", "eventAction": "[ACTION]", "eventLabel": "[CTA]", "eventName": "saving_calculator", "amount": [INV_AMOUNT], "currency_code": "[CURRENCY]", "duration": [DURATION], "monthly_installment": [INSTALLMENT], "saved_amount": [SAVED_AMOUNT]  }';
			dataLayerValue = dataLayerValue
								.replace('[ACTION]', loan.activeSavingsAccountCode)
								.replace('[SAVED_AMOUNT]', loan.savedAmount)
			;
		}
		else if(productCategory === "COMBIPRODUCT") {
			dataLayerValue = '{ "event": "investment_calculator", "eventCategory": "investment", "eventAction": "[ACTION]", "eventLabel": "[CTA]", "eventName": "investment_calculator", "amount": [INV_AMOUNT], "currency_code": "[CURRENCY]", "mutual_fund": [MUTUAL_FUND], "monthly_appreciation": [MONTHLY_APPRECIATION], "appreciation": [APPRECIATION], "fund_combination": "[FUND_COMBINATION]" }';
			dataLayerValue = dataLayerValue
								.replace('[ACTION]', productCategory)
								.replace('[MUTUAL_FUND]', loan.eurizonMutualFund.toFixed(2))
								.replace('[MONTHLY_APPRECIATION]', loan.month12Appreciation.toFixed(2))
								.replace('[APPRECIATION]', loan.singleFundInvestment.toFixed(2))
								.replace('[FUND_COMBINATION]', loan.selectedFunds.map(function(fundCode) { return calculatorLabels.fund[fundCode]; }).join(", "))
			;

		}

		dataLayerValue = dataLayerValue
							.replace('[INV_AMOUNT]', loan.investmentAmount.toFixed(2))
							.replace('[CURRENCY]', loan.activeCurrency.currency)
							.replace('[DURATION]', loan.tenorInYears)
							.replace('[INSTALLMENT]', loan.monthlyInstallment.toFixed(2))
		;

		loan.dataLayer = dataLayerValue;
	}


	/**
	 * Attach Data Layer Click Event
	 *
	 */
	this.attachDataLayerClickEvent = function() {
		$( document ).on( 'click', '[data-layer-vub-calculator]', function(e) {
			var data = loan.dataLayer;

			if($(e.target).hasClass( 'js-callmecta')) {
				data = data.replace('[CTA]', "Call Me Back");
			}
			else {
				data = data.replace('[CTA]', "Get It Now");
			}
			data = JSON.parse( data );

			window.dataLayer.push( data );
		} );
	};

	this.getProductCategory = function() {
		if(loan.activeVariant) {
			return loan.activeVariant.productCategory;
		}
	}

	this.getYearsLabel = function(years) {
		var lang = document.documentElement.lang;
		if(lang === "sk") {
			console.log("SK LANGUAGE")
			if(years === 1) {
				return calculatorLabels["YEAR"];
			}
			else if(years === 3 || years === 4)
			{
				return calculatorLabels["YEARS34"];
			}
			else {
				return calculatorLabels["YEARS"];
			}
		}
		else {
			if (years === 1) return calculatorLabels["YEAR"];
			else return calculatorLabels["YEARS"];
		}

	}

};


/**
 * Get class instance
 *
 */
Intesa.InvestmentCalculatorVUB.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

    }

	if( !window.intesa.investment_calculator_vub ) {

		window.intesa.investment_calculator_vub = new Intesa.InvestmentCalculatorVUB();

	}

	return window.intesa.investment_calculator_vub;

};